import React from 'react';
import { string, bool } from 'prop-types';
import classnames from 'classnames';
import { Prices } from 'components';
import { productShape } from 'shapes';
import { Ratings } from './components';
import './DescriptionBlock.scss';

export default function DescriptionBlock({
    className,
    product,
    locale,
    currency,
    isB2B,
    isForeignSeller,
    showRatings,
    useGenericTitle,
}) {
    const productTitle = useGenericTitle
        ? product.title
        : product.default_title;
    const rootClassnames = classnames('description-block', className);

    return (
        <div className={rootClassnames}>
            <Prices
                className="description-block__prices"
                prices={product.prices}
                locale={locale}
                currency={currency}
                isVATExcluded={isB2B}
                isForeignSeller={isForeignSeller}
                showFromPrice={product.models_count > 1}
                showDiscount
                showRetailPrice
                preserveProportions
            />

            <div className="description-block__title">{productTitle}</div>

            {showRatings && (
                <Ratings
                    className="description-block__rating"
                    stars={product.rating}
                    count={product.rating_count}
                />
            )}
        </div>
    );
}

DescriptionBlock.propTypes = {
    className: string,
    product: productShape.isRequired,
    currency: string.isRequired,
    locale: string.isRequired,
    isB2B: bool,
    isForeignSeller: bool,
    showRatings: bool,
    useGenericTitle: bool,
};

DescriptionBlock.defaultProps = {
    className: null,
    isB2B: false,
    isForeignSeller: false,
    showRatings: false,
    useGenericTitle: false,
};
